/* Agregar al carrito sin salir de la pagina.
   Hace el POST por fetch y despues abre el carrito lateral del tema
   (<cart-drawer-component>), que escucha 'cart:update'. Si la tienda esta
   configurada con pagina de carrito en vez de cajon, cae a /cart. */
(function () {
  if (window.gfCart) { return; }

  function avisarYAbrir(cart, origen) {
    /* El tema arma este evento desde product-form.js; replicamos la forma.
       Sin 'sections' el componente de items se re-renderiza solo contra el
       servidor, que es lo que queremos: no tenemos su HTML a mano. */
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: origen || 'griflor',
        data: {
          source: 'product-form-component',
          itemCount: cart ? cart.item_count : undefined,
          didError: false
        }
      }
    }));

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) { window.location.href = '/cart'; return false; }

    /* Con auto-open el propio drawer ya se abrio con el evento de arriba.
       Sin el atributo lo abrimos a mano, esperando a que el custom element
       este definido (los modulos del tema cargan diferidos). */
    if (!drawer.hasAttribute('auto-open')) {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('cart-drawer-component').then(function () {
          if (typeof drawer.open === 'function') { drawer.open(); }
        });
      } else if (typeof drawer.open === 'function') {
        drawer.open();
      }
    }
    return true;
  }

  window.gfCart = {
    /** @returns {Promise<object>} el carrito ya actualizado */
    agregar: function (id, cantidad, origen) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: parseInt(cantidad, 10) || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) { throw new Error('add'); }
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          avisarYAbrir(cart, origen);
          return cart;
        });
    }
  };
})();
